"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const types_1 = require("../types");
const BasicNode_1 = require("./BasicNode");
const AdoptionNodeValidation_1 = require("../validations/AdoptionNodeValidation");
class AdoptionNode extends BasicNode_1.BasicNode {
  constructor(props) {
    if (!props) props = { type: types_1.NODE_TYPES.ADOPTION };
    if (props.type !== types_1.NODE_TYPES.ADOPTION)
      throw new Error("Invalid Node type");
    super(props);
  }
  deserialize(data) {
    let nodeData = data || this.getNodeData();
    let deserializeData = nodeData || {
      templatesToAdopt: []
    };
    return deserializeData;
  }
  serialize(uiData) {
    let nodeData = uiData;
    return nodeData;
  }
  validate() {
    return new AdoptionNodeValidation_1.AdoptionNodeValidation().validate(this);
  }
  setId(props) {
    this.setBasicNodeId(props);
  }
}
exports.AdoptionNode = AdoptionNode;
//# sourceMappingURL=AdoptionNode.js.map
